import logo from './logo.svg';
import './App.css';
import { Amplify } from 'aws-amplify';
import awsmobile from './amplifyconfiguration';
import  {Provider}  from 'react-redux';

import store from './store/Store';
import Application from './application';
Amplify.configure(awsmobile);


function App({ Component, pageProps }) {
  
  return (
     <Provider store={store}>
        <Application/>
    </Provider>
  );
}

export default App;

